import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { showAlert } from 'utility/SweetAlert'

const InteractorCorporateOrganizationUpdate = () => {
  const corporateOrganizationUpdate = useCallback((body, loading) => {
    const payload = {
      ...body,
    }
    const isAlert = body.alert ?? false
    ApiService.jsonRequest('/corporate/organization/update', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        if (isAlert) {
          showAlert({
            icon: 'success',
            message:
              payload.is_deleted === 'Y'
                ? getTranslate('message.successfully_deleted')
                : getTranslate('message.successfully_updated'),
            timer: 2000,
            redirect: '/company/organization/manage',
          })
        }
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
        })
      }
    })
  }, [])
  return { corporateOrganizationUpdate }
}

export default InteractorCorporateOrganizationUpdate
